import { Dropdown_Button_default } from "./chunk-GUHNAMKF.js";
import { Dropdown_Panel_default } from "./chunk-6EE3W4LI.js";
import { Dropdown_default } from "./chunk-OC3XUHGA.js";

// src/elements/Dropdown/index.ts
var DropdownComponent = Dropdown_default;
DropdownComponent.Button = Dropdown_Button_default;
DropdownComponent.Button.displayName = "Dropdown.Button";
DropdownComponent.Panel = Dropdown_Panel_default;
DropdownComponent.Panel.displayName = "Dropdown.Panel";
export { DropdownComponent };